const initialState = {
    items: []
};

const logReducer = (state = initialState, action) => {

    if (action.type === 'ADD_TO_LOG') {

        return {
            ...state,
            items: [ ...state.items, action.payload ] 
        }
        
    }

    if (action.type === 'GET_LOG') {

        return {
            ...state
        }

    }

    return state;

}

export default logReducer;